export const transitionData = {
  type: 'tween',
  delay: 0,
  duration: 0.3,
  ease: [0.1, 0, 0, 1],
};
